export const AUTH_STORAGE_KEY = 'lyncs-web-auth-session';

export const DEFAULT_AUTH_CREDENTIALS = {
  username: 'faris.admin',
  email: 'faris@lyncs.sa',
  password: 'Lyncs@2026',
};

export const DEFAULT_AUTH_USER = {
  name: 'Faris Ahmed',
  role: 'Administrator',
  username: DEFAULT_AUTH_CREDENTIALS.username,
  email: DEFAULT_AUTH_CREDENTIALS.email,
};
